import actions from './constants';

export const fetchDatasetMembers = (assignable, filter) => ({
  assignable,
  filter,
  type: actions.FETCH_DATASET_MEMBERS,
});

export const updateDatasetMembersProperties = (assignable, properties) => ({
  type: actions.UPDATE_DATASET_MEMBERS_PROPERTIES,
  assignable,
  properties,
});

export const showShareDataset = (category, code, name) => ({
  category,
  code,
  name,
  type: actions.SHOW_SHARE_DATASET,
});

export const hideShareDataset = () => ({
  type: actions.HIDE_SHARE_DATASET,
});

export const showDatasetMembers = (results, resultsCount, assignable) => ({
  assignable,
  results,
  resultsCount,
  type: actions.SHOW_DATASET_MEMBERS,
});

export const showDatasetMembersError = (error, assignable) => ({
  assignable,
  error,
  type: actions.SHOW_DATASET_MEMBERS_ERROR,
});

export const updateShareDatasetProperties = (properties) => ({
  properties,
  type: actions.UPDATE_SHARE_DATASET_PROPERTIES,
});

export const addDatasetMembers = () => ({
  type: actions.ADD_DATASET_MEMBERS,
});

export const removeDatasetMember = (memberID) => ({
  type: actions.REMOVE_DATASET_MEMBER,
  memberID,
});

export const updateDatasetMemberPermissions = (memberID, permissions) => ({
  permissions,
  type: actions.UPDATE_DATASET_MEMBER_PERMISSIONS,
  memberID,
});

export const shareDataset = () => ({
  type: actions.SHARE_DATASET,
});

export const shareDatasetSuccess = (code, name, members, destroy) => ({
  code, destroy, name, type: actions.SHARE_DATASET_SUCCESS, members,
});

export const shareDatasetError = (code, name, members) => ({
  code, name, type: actions.SHARE_DATASET_ERROR, members,
});

export const showDatasetPermissions = (category, code, result) => ({
  category,
  code,
  result,
  type: actions.SHOW_DATASET_PERMISSIONS,
});

export const showDatasetPermissionsError = (category, code, error) => ({
  category,
  code,
  error,
  type: actions.SHOW_DATASET_PERMISSIONS_ERROR,
});
